import {NgModule} from '@angular/core';
import {TrackerComponent} from './tracker.component';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from '../../_guards/auth.guard';
import {RouteGuard} from '../../_guards/route.guard';
import {PermissionsGuard} from '../../_guards/permissions.guard';

const routes: Routes = [
    {
        path: 'tracker',
        component: TrackerComponent,
        canActivate: [
            AuthGuard,
            RouteGuard,
        ],
        /*'canActivateChild': [
            PermissionsGuard
        ],*/
        children: [
            {
                path: 'index',
                loadChildren: () => import('./home/tracker.home.module').then(m => m.TrackerHomeModule)
            },
            {
                path: 'vehicle/:vehicle_id',
                loadChildren: () => import('./home/tracker.home.module').then(m => m.TrackerHomeModule)
            },
            {
                path: 'view/:event_id/:vehicle_id',
                loadChildren: () => import('./home/tracker.home.module').then(m => m.TrackerHomeModule)
            },
            {
                path: 'view/:event_id/:vehicle_id/:type',
                loadChildren: () => import('./home/tracker.home.module').then(m => m.TrackerHomeModule)
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TrackerRoutingModule {
}
